module.exports = __webpack_public_path__ + "img/aether_e.rplanet.bd1e688.png";